import { RecordsController } from "../../controllers";
import { ComponentBase } from "../_ComponentBase";

/**
 * UI for records of the entity .
 * @example
 * ```html
 * <salaxy-records entity-type="'employment'" api-ctrl="$worker"></salaxy-records>
 * ```
 */
export class Records extends ComponentBase {

    /**
     * The following component properties (attributes in HTML) are bound to the Controller.
     * For detailed functionality, refer to [controller](#controller) implementation.
     */
    public bindings = {
     /**
      * Binding to entity type
      */
      entityType: "<",

      /** Expression for the api controller . */
      apiCtrl: "<",

      /** Binding to read only state */
      readOnly: "<"

    };

    /** Uses the WorkerRecordsController */
    public controller = RecordsController;

    /** The default template for the component. */
    public defaultTemplate = "salaxy-components/records/Records.html";

}
